"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readyToSubmit = exports.DoNotSubmitErrors = exports.SubmitToCourtError = exports.SubmitStatus = exports.NOT_SURE_SUBMIT_UPDATE_ID = exports.YES_SUBMIT_UPDATE_ID = exports.NO_SUBMIT_UPDATE_ID = void 0;
const __1 = require("..");
const court_1 = require("../court");
const customers_1 = require("../customers");
const customers_2 = require("../customers");
const helpers_1 = require("../customers/helpers");
const documents_1 = require("../documents");
const helpers_2 = __importDefault(require("../economy/helpers"));
const interest_1 = require("../economy/helpers/interest");
const vouchers_1 = require("../economy/helpers/vouchers");
const vouchers_2 = require("../economy/vouchers");
const interactions_1 = require("../interactions");
const tribunal_1 = require("../tribunal");
const updates_1 = require("../updates");
exports.NO_SUBMIT_UPDATE_ID = updates_1.UpdateType.NoCourtSubmit;
exports.YES_SUBMIT_UPDATE_ID = updates_1.UpdateType.YesCourtSubmit;
exports.NOT_SURE_SUBMIT_UPDATE_ID = updates_1.UpdateType.NotSureCourtSubmit;
var SubmitStatus;
(function (SubmitStatus) {
    SubmitStatus["Yes"] = "YES";
    SubmitStatus["No"] = "NO";
    SubmitStatus["NotSure"] = "NOT_SURE";
})(SubmitStatus || (exports.SubmitStatus = SubmitStatus = {}));
var SubmitToCourtError;
(function (SubmitToCourtError) {
    SubmitToCourtError["IsNotWarned"] = "IS_NOT_WARNED";
    SubmitToCourtError["CurrencyNotDKK"] = "CURRENCY_NOT_DKK";
    SubmitToCourtError["WarningWasReturned"] = "WARNING_WAS_RETURNED";
    SubmitToCourtError["AlreadyHasFoundation"] = "ALREADY_HAS_FOUNDATION";
    SubmitToCourtError["MoreThanOneDebtor"] = "MORE_THAN_ONE_DEBTOR";
    SubmitToCourtError["HasAlternativeContact"] = "HAS_ALTERNATIVE_CONTACT";
    SubmitToCourtError["EconomyContactMissing"] = "ECONOMY_CONTACT_MISSING";
    SubmitToCourtError["CreditorNameMissing"] = "CREDITOR_NAME_MISSING";
    SubmitToCourtError["CreditorAddressMissing"] = "CREDITOR_ADDRESS_MISSING";
    SubmitToCourtError["CompanyFullResponsibleParticipantMissing"] = "COMPANY_FULL_RESPONSIBLE_PARTICIPANT_MISSING";
    SubmitToCourtError["CompanyDirectorNameMissing"] = "COMPANY_DIRECTOR_NAME_MISSING";
    SubmitToCourtError["CompanyDirectorAddressMissing"] = "COMPANY_DIRECTOR_ADDRESS_MISSING";
    SubmitToCourtError["JurisdictionMissing"] = "JURISDICTION_MISSING";
    SubmitToCourtError["EconomicalSubmitThreshold"] = "ECONOMICAL_SUBMIT_THRESHOLD";
    SubmitToCourtError["SagsfremstillingMissing"] = "HAS_CASE_PRESENTATION";
    SubmitToCourtError["CaseHasExceededMaxDebtRegistrationsThreshold"] = "CASE_HAS_EXCEEDED_MAX_DEBT_REGISTRATIONS_THRESHOLD";
    SubmitToCourtError["AlreadyInCourt"] = "ALREADY_IN_COURT";
    SubmitToCourtError["AddressNotInDK"] = "ADDRESS_NOT_IN_DK";
    SubmitToCourtError["DebtorMovedAbroad"] = "DEBTOR_MOVED_ABROAD";
    SubmitToCourtError["CaseHasDeposits"] = "CASE_HAS_DEPOSITS";
    SubmitToCourtError["DebtorBankrupt"] = "DEBTOR_BANKRUPT";
    SubmitToCourtError["DebtorCompanyCeased"] = "DEBTOR_COMPANY_CEASED";
    SubmitToCourtError["DebtorDead"] = "DEBTOR_DEAD";
    SubmitToCourtError["DebtorHomeless"] = "DEBTOR_HOMELESS";
    SubmitToCourtError["ExcessiveReminderFeeImposed"] = "EXCESSIVE_REMINDER_FEE_IMPOSED";
    SubmitToCourtError["ExcessiveCollectionFeeImposed"] = "EXCESSIVE_COLLECTION_FEE_IMPOSED";
    SubmitToCourtError["ExcessiveCollectionCostImposed"] = "EXCESSIVE_COLLECTION_COST_IMPOSED";
    SubmitToCourtError["ExcessivePrincipal"] = "EXCESSIVE_PRINCIPAL";
})(SubmitToCourtError || (exports.SubmitToCourtError = SubmitToCourtError = {}));
exports.DoNotSubmitErrors = [
    SubmitToCourtError.CurrencyNotDKK,
    SubmitToCourtError.AlreadyHasFoundation,
    SubmitToCourtError.EconomicalSubmitThreshold,
    SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold,
];
const readyToSubmit = (validationData, config) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { interactions, caseVouchers, customer, creditor, documents, templates, updates, tenant, } = validationData;
    let errors = [];
    const warningInteractions = (0, court_1.getWarnings)(interactions, templates);
    const warningUpdates = (0, court_1.getWarningUpdates)(updates);
    if (warningInteractions.length === 0 && warningUpdates.length === 0) {
        errors.push(SubmitToCourtError.IsNotWarned);
    }
    const warningDelivered = warningInteractions.find((warning) => {
        if (warning.type === interactions_1.InteractionType.Email) {
            const emailDelivered = warning.events.find((event) => event.type === 'delivered');
            return emailDelivered;
        }
        else if (warning.type === interactions_1.InteractionType.Letter) {
            const letterNotDelivered = warning.events.find((event) => [
                interactions_1.ReturnReason.DENIED,
                interactions_1.ReturnReason.NOTDELIVERABLE,
                interactions_1.ReturnReason.UNKNOWNRECIPIENT,
            ].includes(event.type));
            return !letterNotDelivered;
        }
        else if (warning.type === interactions_1.InteractionType.Eboks) {
            const eboksDelivered = warning.events.find((event) => event.type === 'delivered');
            return eboksDelivered;
        }
        return false;
    });
    if (warningInteractions.length > 0 &&
        !warningDelivered &&
        warningUpdates.length === 0) {
        errors.push(SubmitToCourtError.WarningWasReturned);
    }
    if (((_a = caseVouchers[0]) === null || _a === void 0 ? void 0 : _a.currency) !== 'DKK') {
        errors.push(SubmitToCourtError.CurrencyNotDKK);
    }
    if (caseVouchers.find((caseVoucher) => caseVoucher.voucherTypeId === vouchers_2.VoucherTypeIds.DEPOSIT)) {
        errors.push(SubmitToCourtError.CaseHasDeposits);
    }
    const foundations = documents.filter(documents_1.isDocumentFoundation);
    if (foundations.length > 0) {
        errors.push(SubmitToCourtError.AlreadyHasFoundation);
    }
    if ((0, customers_1.getDebtorsOnCustomer)(customer).length > 1) {
        errors.push(SubmitToCourtError.MoreThanOneDebtor);
    }
    if (customer.users.filter((user) => user.relation === 'alternative-contact')
        .length > 0) {
        errors.push(SubmitToCourtError.HasAlternativeContact);
    }
    if ((config === null || config === void 0 ? void 0 : config.sendInfoToEconomyResponsible) &&
        !config.economyResponsibleUserId) {
        errors.push(SubmitToCourtError.EconomyContactMissing);
    }
    if (!creditor.name) {
        errors.push(SubmitToCourtError.CreditorNameMissing);
    }
    if (!(0, __1.validateAddress)(creditor.address)) {
        errors.push(SubmitToCourtError.CreditorAddressMissing);
    }
    if ((config === null || config === void 0 ? void 0 : config.economicalThreshold) &&
        config.economicalThreshold >
            -helpers_2.default.overview.balance(caseVouchers, {
                filter: {
                    includeDeletedVouchers: false,
                    includeExpiredVouchers: false,
                    includeIrrecoverableVouchers: false,
                },
            })) {
        errors.push(SubmitToCourtError.EconomicalSubmitThreshold);
    }
    const reminderFeesSum = -helpers_2.default.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, vouchers_2.VoucherTypeIds.REMINDERFEE);
    if ((config === null || config === void 0 ? void 0 : config.reminderFeesMaximumPerPrincipal)
        ? reminderFeesSum >
            30000 *
                caseVouchers.filter((caseVoucher) => caseVoucher.category === vouchers_2.VoucherCategory.PRINCIPAL).length
        : reminderFeesSum > 30000) {
        errors.push(SubmitToCourtError.ExcessiveReminderFeeImposed);
    }
    const collectionFeesSum = -helpers_2.default.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, vouchers_2.VoucherTypeIds.COLLECTIONFEE);
    if (collectionFeesSum > 10000) {
        errors.push(SubmitToCourtError.ExcessiveCollectionFeeImposed);
    }
    const principalSum = -helpers_2.default.overview.balanceCategory(caseVouchers, vouchers_2.VoucherCategory.PRINCIPAL, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    });
    if (principalSum > 10000000) {
        errors.push(SubmitToCourtError.ExcessivePrincipal);
    }
    const collectionCostSum = -helpers_2.default.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, vouchers_2.VoucherTypeIds.COLLECTIONCOST);
    let selfCollection = false;
    if (creditor.selfCollection != null) {
        selfCollection = creditor.selfCollection;
    }
    else {
        selfCollection = !!tenant.settings.selfCollection;
    }
    const calculatedCollectionCost = (0, vouchers_1.calcCollectionCost)(caseVouchers, documents, (0, interest_1.getExpirationSettings)(tenant, creditor), selfCollection, tenant.countryCode);
    if (collectionCostSum > calculatedCollectionCost) {
        errors.push(SubmitToCourtError.ExcessiveCollectionCostImposed);
    }
    const debtor = (0, customers_1.getContactPerson)(customer);
    if ((debtor === null || debtor === void 0 ? void 0 : debtor.details.companyStatus) === 'Ophørt') {
        errors.push(SubmitToCourtError.DebtorCompanyCeased);
    }
    if (((debtor === null || debtor === void 0 ? void 0 : debtor.details.companyStatus) &&
        [
            'UNDERKONKURS',
            'OPLØSTEFTERKONKURS',
            'UNDERTVANGSOPLØSNING',
            'TVANGSOPLØST',
            'OPLØSTEFTERFUSION',
            'OPLØSTEFTERERKLÆRING',
            'OPLØSTEFTERFRIVILLIGLIKVIDATION',
            'UNDERFRIVILLIGLIKVIDATION',
            'SLETTET',
        ].includes(debtor === null || debtor === void 0 ? void 0 : debtor.details.companyStatus)) ||
        (((_c = (_b = debtor === null || debtor === void 0 ? void 0 : debtor.details) === null || _b === void 0 ? void 0 : _b.status) === null || _c === void 0 ? void 0 : _c.stage) &&
            debtor.details.status.stage !== customers_1.CompanyStarCycle.Active)) {
        errors.push(SubmitToCourtError.DebtorBankrupt);
    }
    if ((debtor === null || debtor === void 0 ? void 0 : debtor.details.aksError) === 'Personen kunne identificeres, men er død' ||
        ((_d = debtor === null || debtor === void 0 ? void 0 : debtor.details.status) === null || _d === void 0 ? void 0 : _d.stage) === customers_2.PrivateStarCycle.Dead) {
        errors.push(SubmitToCourtError.DebtorDead);
    }
    if (((_e = debtor === null || debtor === void 0 ? void 0 : debtor.details.status) === null || _e === void 0 ? void 0 : _e.stage) === customers_2.PrivateStarCycle.Homeless) {
        errors.push(SubmitToCourtError.DebtorHomeless);
    }
    const debtorCountry = (_g = (_f = debtor === null || debtor === void 0 ? void 0 : debtor.details) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.country;
    if (debtorCountry &&
        !['danmark', 'denmark', 'dk'].includes(debtorCountry.toLocaleLowerCase())) {
        errors.push(SubmitToCourtError.AddressNotInDK);
    }
    if (debtor === null || debtor === void 0 ? void 0 : debtor.details.movedAbroad) {
        errors.push(SubmitToCourtError.DebtorMovedAbroad);
    }
    const rkiRegistrations = debtor && (0, helpers_1.getRKIRegistrations)(debtor.details);
    if (typeof (config === null || config === void 0 ? void 0 : config.maxDebtRegistrations) === 'number' &&
        rkiRegistrations &&
        rkiRegistrations.length > (config === null || config === void 0 ? void 0 : config.maxDebtRegistrations)) {
        errors.push(SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold);
    }
    if (!(config === null || config === void 0 ? void 0 : config.sagsfremstilling) || config.sagsfremstilling.length < 50) {
        errors.push(SubmitToCourtError.SagsfremstillingMissing);
    }
    if (!(debtor === null || debtor === void 0 ? void 0 : debtor.details.courtId)) {
        errors.push(SubmitToCourtError.JurisdictionMissing);
    }
    if ((debtor === null || debtor === void 0 ? void 0 : debtor.details.virksomhedsform) &&
        selskabsformer[debtor === null || debtor === void 0 ? void 0 : debtor.details.virksomhedsform]) {
        const director = (0, court_1.getDirector)(customer.users);
        if (!(director === null || director === void 0 ? void 0 : director.address)) {
            errors.push(SubmitToCourtError.CompanyDirectorAddressMissing);
        }
        if (!(director === null || director === void 0 ? void 0 : director.name)) {
            errors.push(SubmitToCourtError.CompanyDirectorNameMissing);
        }
    }
    if ((debtor === null || debtor === void 0 ? void 0 : debtor.details.virksomhedsform) &&
        personligtEjetVirksomhed[debtor === null || debtor === void 0 ? void 0 : debtor.details.virksomhedsform]) {
        const fuldtAnsvaligeDeltagere = (0, court_1.getFuldtAnsvaligeDeltagere)(customer.users);
        if (!(fuldtAnsvaligeDeltagere && fuldtAnsvaligeDeltagere.find((f) => f.name))) {
            errors.push(SubmitToCourtError.CompanyFullResponsibleParticipantMissing);
        }
    }
    if (updates.find((update) => tribunal_1.ISINCOURTUPDATESTYPES.includes(update.updateTypeId))) {
        errors.push(SubmitToCourtError.AlreadyInCourt);
    }
    errors = (config === null || config === void 0 ? void 0 : config.incluededRules)
        ? errors.filter((e) => {
            return config.incluededRules.find((rule) => e === rule);
        })
        : errors;
    return {
        errors,
        status: errors.length === 0
            ? SubmitStatus.Yes
            : errors.some((error) => exports.DoNotSubmitErrors.includes(error))
                ? SubmitStatus.No
                : SubmitStatus.NotSure,
    };
};
exports.readyToSubmit = readyToSubmit;
const selskabsformer = {
    ['Anpartsselskab']: true,
    ['Aktieselskab']: true,
    ['Iværksætterselskab']: true,
};
const personligtEjetVirksomhed = {
    ['Enkeltmandsvirksomhed']: true,
    ['Interessentskab']: true,
    ['Personligt ejet Mindre Virksomhed']: true,
};
//# sourceMappingURL=auto-submit.js.map